export enum StreamaxRecordOverwrite {
    ByDays = 0,
    ByCapacity = 1,
    Disabled = 2,
    ByMinutes = 4
}

export enum FtCloudConfigExceptionError {
    RecordOverwrite,
    IgnitionDelay,
    CameraCoveredAlarmToggle,
    CameraCoveredAlarmTrigger,
    VideoLossAlarmToggle,
    VideoLossAlarmTrigger,
    AcceleratorAlarmToggle,
    HarshBrakingTrigger,
    HardAccelerationTrigger,
    HarshRightTurnTrigger,
    HarshLeftTurnTrigger,
    HarshBrakingTriggerMetrics,
    HardAccelerationTriggerMetrics,
    HarshRightTurnTriggerMetrics,
    HarshLeftTurnTriggerMetrics,
    GyroMetrics,
    Timezone,
    DaylightSavingsToggle,
    DaylightSavingsOffset,
    AudioToggle,
    Uncollected
}

export enum CameraCoveredAlarmSensitivity {
    High,
    Medium,
    Low
}

export enum ChannelFlag {
    None = 0,
    Channel1 = 1,
    Channel2 = 2,
    Channel3 = 4,
    Channel4 = 8,
    Channel5 = 16,
    Channel6 = 32,
    Channel7 = 64,
    Channel8 = 128,
    Channel9 = 256,
    Channel10 = 512,
    Channel11 = 1024,
    Channel12 = 2048,
    Channel13 = 4096,
    Channel14 = 8192,
    Channel15 = 16384,
    Channel16 = 32768
}

export enum DSTOffsetMonth {
    January,
    February,
    March,
    April,
    May,
    June,
    July,
    August,
    September,
    October,
    November,
    December
}

export enum DSTOffsetWeek {
    FirstWeekOfMonth,
    SecondWeekOfMonth,
    ThirdWeekOfMonth,
    FourthWeekOfMonth,
    LastWeekOfMonth
}

export enum DSTOffsetDay {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday
}

export enum CalcType {
    DeviceComms,
    TotalErrors,
    TotalSync
}

export enum SegmentClass {
    Positive,
    Negative,
    Uncollected
}
